<template>
    <ai-grid-ro
        ref="gridRoRef"
        :meta="meta"
        :showFilterPanel="showFilterPanel"
        :showToolbar="showToolbar"
        :userSettingsEnabled="userSettingsEnabled"
        :preselectedRows="preselectedRows"
        :action="action"
        :toolbarConfig="toolbarConfig"
        :showGridFooter="showGridFooter"
        :showColumnHeaders="showColumnHeaders"
        :args="args"
        :rowClickCallBack="rowClickCallBack"
        :toolbarUserItems="toolbarUserItems"
        :toRemoveToolbarItemsNames="toRemoveToolbarItemsNames"
        :preferencesState="preferencesState"
        :autoLoadData="autoLoadData"
        @user-settings-changed="onUserSettingsChanged"
        @user-settings-reset="onUserSettingsReset"
        @grid-ro-focus-changed="onGridRoFocusChanged"
    />
</template>

<script>
export default {
    name: 'ai-grid-ro-wrapper',
};
</script>

<script setup>
import { ref, watch, onMounted } from 'vue';
import AiGridRo from '../ai-grid-ro/ai-grid-ro.vue';
import { mainState, setIsReloadValue } from '@/layouts/main-layout/main-layout-data';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {
        },
    },
    dataSource: {
        type: Array,
        default: null,
    },
    action: {
        type: Function,
        default: null,
    },
    toolbarConfig: {
        type: Object,
        default: () => {
        },
    },
    preselectedRows: {
        type: Array,
        default: () => [],
    },
    userSettingsEnabled: {
        type: Boolean,
        default: true,
    },
    showToolbar: {
        type: Boolean,
        default: true,
    },
    showFilterPanel: {
        type: Boolean,
        default: true,
    },
    showGridFooter: {
        type: Boolean,
        default: true,
    },
    showColumnHeaders: {
        type: Boolean,
        default: true,
    },
    args: {
        type: Object,
        default: () => {
        },
    },
    rowClickCallBack: {
        type: Function,
        default: () => {
        },
    },
    toolbarUserItems: {
        type: Array,
        default: () => [],
    },
    toRemoveToolbarItemsNames: {
        type: Array,
        default: () => ['choice'],
    },
    preferencesState: {
        type: Boolean,
        default: true,
    },
    autoLoadData: {
        type: Boolean,
        default: true,
    },
    hasntRoute: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['userSettingsChanged', 'userSettingsReset', 'gridRoFocusChanged']);

const gridRoRef = ref();

watch(
    () => mainState.routePath,
    async () => {
        await gridRoRef.value.setCacheOrApiDataSource(props.dataSource);
        emit('dataLoaded');
    },
);

onMounted(async () => {
    if (mainState.isReload || props.hasntRoute) {
        await gridRoRef.value.setCacheOrApiDataSource(props.dataSource);
        setIsReloadValue(false);
    }
});

const onUserSettingsChanged = event => {
    emit('userSettingsChanged', event);
};

const onUserSettingsReset = () => {
    emit('userSettingsReset');
};

const onGridRoFocusChanged = (row, viewId, rowIndex, component) => {
    emit('gridRoFocusChanged', row, viewId, rowIndex, component);
};

defineExpose({
    ref: gridRoRef,
});
</script>
